<div class="bc-panel bc-layout-wrapper" [ngClass]="{ 'canned-message-inline': !isExpanded }" [hidden]="!isOpened">
  <div class="bc-canned-message-panel" [attr.data-automation-id]="'bc-canned-message-panel'">

    <div class="bc-canned-message-header-title">
      <svg-icon icon="can-outline"></svg-icon>
      <span>{{ 'bcCannedMessagePanel.cannedMessagesLabel' | translate }}</span>
    </div>

    <div class="bc-canned-message-top-bar">
      <app-auto-save [model]="selectedCannedMessageFolder"
                     [storageKey]="'selectedCannedMessageFolder-' + workItemId"></app-auto-save>
      <div *ngIf="cannedMessageFolders">
        <!-- Folder select dropdown -->
        <app-hierarchy-dropdown #hierarchyDropdown
                                [items]="cannedMessageFolders"
                                [value]="selectedCannedMessageFolder?.id"
                                (onItemSelected)="cannedMessageFolderChange($event)"
                                (onDropdownToggled)="onDropdownToggle($event)"
                                [textPropertyName]="'name'"
                                [sortFieldsByText]="true"
                                [disabled]="shouldDisableDropdown()"
                                [iconNameForDropdown]="'folder'"
                                class="bc-canned-message-folder-list"
                                [attr.data-automation-id]="'bc-canned-message-folder-list'">
        </app-hierarchy-dropdown>

        <!-- Canned message Search field -->
        <div class="bc-canned-message-search-wrapper input-search">
          <svg-icon icon="magnifier"></svg-icon>
          <input #searchField
                 type="text"
                 class="bc-canned-message-search-field"
                 [attr.data-automation-id]="'bc-canned-message-search'"
                 (focus)="onSearchFieldFocus()"
                 (blur)="onSearchFieldBlur()"
                 [ngModel]="searchQuery"
                 (ngModelChange)="searchQueryChanged($event)"
                 [placeholder]="'bcCannedMessagePanel.searchPlaceholder' | translate"
                 [disabled]="dropdownError"
                 (keydown)="handleKeyDown($event)"/>
          <span *ngIf="searchQuery" class="icon fa fa-times-circle" (click)="clearSearchQuery()"></span>
        </div>
      </div>

      <svg-icon *ngIf="!isExpanded" icon="x" class="bc-canned-message-panel-close" (click)="closePanel()">
      </svg-icon>
    </div>

    <!-- Canned message list -->
    <div class="gradient-wrapper" *ngIf="!cannedMessagesAreLoading">
      <ul class="bc-canned-message-container bc-list" #parentScrollElement>
        <virtual-scroller *ngIf="filteredMessages.length !== 0" [items]="filteredMessages" [bufferAmount]="4"
                          [parentScroll]="parentScrollElement" (vsUpdate)="cannedMessageVirtualListUpdated($event)"
                          (vsStart)="virtualStartIndexChanged($event)" class="virtual-scroll-container" #virtualScrollerElement>
          <div *ngFor="let message of virtualFilteredMessages; let i = index">
            <div
              (click)="cannedMessageClick(message)"
              (mouseover)="setActiveIndex(virtualStartIndex + i)"
              class="bc-canned-message-wrapper bc-list-row"
              [ngClass]="{'key-cursor': isSearchFieldFocused && (virtualStartIndex + i === activeCannedMessageIndex)}"
              [attr.data-id]="virtualStartIndex + i"
              [attr.data-automation-id]="'bc-canned-message-wrapper'">
              <div class="bc-canned-message-element">
                <div title="{{message.name | appInnerText | slice:0:500 }}"
                     [innerHTML]="message.name | appHighlight:searchQuery"
                     class="bc-canned-message-title"
                     [attr.data-automation-id]="'bc-canned-message-title'">
                </div>
                <span *ngIf="message.slashCommand"
                      class="bc-canned-message-slash-command"
                      [attr.data-automation-id]="'bc-canned-message-slash-command'">
                        /{{ message.slashCommand }}
                      </span>
                <div *ngIf="searchQuery" class="bc-canned-message-folder-path">
                  {{message.folderPath}}
                </div>
                <div title="{{message.text | appInnerText | slice:0:500 }}"
                     [innerHTML]="message.text | appHighlight:searchQuery"
                     *ngIf="!isImage(message)"
                     class="bc-canned-message-body"
                     [attr.data-automation-id]="'bc-canned-message-body-non-image'">
                </div>
                <img appImageOrientation
                     *ngIf="isImage(message)"
                     class="bc-canned-message-body"
                     [attr.data-automation-id]="'bc-canned-message-body-image'"
                     [src]="message.text"/>
              </div>
            </div>
          </div>
        </virtual-scroller>
        <div *ngIf="searchQuery && filteredMessages.length === 0 && !isMessagesEmpty()"
             class="bc-canned-message-no-result">
          <span>{{ 'bcCannedMessagePanel.noResults' | translate: { searchFilter: searchQuery } }}</span>
        </div>
        <div *ngIf="!searchQuery && filteredMessages.length === 0 && !isMessagesEmpty()"
             class="bc-canned-message-no-result">
          <span>{{ 'bcCannedMessagePanel.noCannedMessagesInFolder' | translate }}</span>
        </div>
        <div *ngIf="isMessagesEmpty()" class="bc-canned-message-no-messages">
          <div class="bc-canned-message-no-messages-wrapper">
            <div class="bc-canned-message-no-messages-title">{{ 'bcCannedMessagePanel.noCannedMessagesInTotal' |
              translate }}</div>
            <div class="bc-canned-message-no-messages-subtext">{{ 'bcCannedMessagePanel.noCannedMessageAdvice' |
              translate }}</div>
          </div>
        </div>
      </ul>
    </div>
    <app-loading *ngIf="cannedMessagesAreLoading"></app-loading>

  </div>
</div>
